import { useState, useCallback, useMemo } from 'react';

export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((type, message, options = {}) => {
    const id = Date.now() + Math.random();
    
    // S'assurer que le message est toujours une string
    let safeMessage = 'Erreur inconnue';
    if (typeof message === 'string') {
      safeMessage = message;
    } else if (message && typeof message === 'object') {
      safeMessage = message.message || message.code || JSON.stringify(message);
    } else if (message !== null && message !== undefined) {
      safeMessage = String(message);
    }
    
    const toast = {
      id,
      type,
      message: safeMessage,
      title: options.title,
      duration: options.duration || 5000,
      autoClose: options.autoClose !== false
    };

    setToasts(prev => [...prev, toast]);
    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  // Référence stable — évite de recréer les useCallback/useEffect qui dépendent de toast
  // (ex. Equipe.loadMemberDetail → boucle GET /equipe/:memberId).
  const toast = useMemo(
    () => ({
      success: (message, options) => showToast('success', message, options),
      error: (message, options) => showToast('error', message, options),
      warning: (message, options) => showToast('warning', message, options),
      info: (message, options) => showToast('info', message, options),
    }),
    [showToast],
  );

  return { toasts, toast, removeToast };
};






